<template>
  <router-link
    :to="{ name: 'manifestDetail', params: { manifestId: manifest.id } }"
    :aria-label="
      t('manifests.manifestNumberParam', { param: manifest.manifestNumber })
    "
    class="shipment-manifest"
  >
    <Card class="shipment-manifest-card elevated">
      <template #content>
        <div class="shipment-manifest-card-content w-full flex flex-column">
          <div class="flex justify-content-between">
            <div
              class="shipment-manifest-card-manifest-number font-medium text-gray-darkest"
            >
              {{
                t('manifests.manifestNumberParam', {
                  param: manifest.manifestNumber,
                })
              }}
            </div>
            <router-link
              :to="{
                name: 'manifestDetail',
                params: { manifestId: manifest.id },
              }"
              class="shipment-manifest-card-link"
            >
              {{ t('common.viewDetails') }}
              <i class="pi pi-arrow-right"></i>
            </router-link>
          </div>
        </div>
      </template>
    </Card>
  </router-link>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { Manifest } from '@/model';

import Card from 'primevue/card';

const props = defineProps({
  manifest: {
    type: Manifest,
    default: () => new Manifest(),
  },
});
const { manifest } = toRefs(props);
const { t } = useI18n();
</script>

<style>
:root {
  --shipment-manifest-card-link-color: var(--p-primary-500);
  --shipment-manifest-card-link-text-decoration: none;
}

a.shipment-manifest {
  --p-card-body-padding: var(--sp-4);

  text-decoration: none;

  .shipment-manifest-card.p-card {
    &:hover {
      --p-card-background: var(--p-surface-100);
      --shipment-manifest-card-link-color: var(--p-primary-600);
      --shipment-manifest-card-link-text-decoration: underline;
    }

    .shipment-manifest-card-content {
      gap: var(--sp-2);

      .shipment-manifest-card-link {
        display: flex;
        align-items: center;
        gap: var(--sp-1);
        color: var(--shipment-manifest-card-link-color);
        text-decoration: var(--shipment-manifest-card-link-text-decoration);

        i.pi {
          font-size: 10px;
        }
      }
    }
  }
}
</style>
